module.exports = __webpack_public_path__ + "img/DSC_0035.82736d8f.jpg";